import React, { useState, useEffect, useCallback } from 'react';
import { Typography, Box, CircularProgress, useTheme, Link, Tabs, Tab, FormControlLabel, Checkbox } from '@mui/material';
import {AddBoxOutlined, InstallMobileRounded, IosShareRounded} from '@mui/icons-material';
import ShowToast from "../components/ToastComponent";
import { LoginSocialGoogle,LoginSocialFacebook } from 'reactjs-social-login';
import { OTPLESS_AUTHENTICATION_SOURCE, OTPLESS_DUROLT_CID, REGEXP_EMAIL, SUCCESS, TOAST_ERROR, TOAST_SUCCESS, TOAST_WARN, HIVEBOARD, BUTTON_PRIMARY, BUTTON_WARNING, ASSIGNMENT_SLUG, PARCEL_PAGE_FLOW } from "../assets/constants/Constants";
import {LOGIN, TERMS_AND_CONDITIONS, LINK_MY_DEVICE, VERIFY_OTP, HOME, LANDING, DOOR_VERIFICATION_PAGE, LOCKER_SIZE_SELECTION} from '../assets/constants/PageList';
import { useTranslation, Trans } from 'react-i18next';
import {FaceBookIcon, GoogleIcon } from "../assets/constants/Icons";
import ButtonComponent from "../components/ButtonComponent";
import { useHistory } from 'react-router-dom';
import 'react-phone-input-2/lib/material.css';
import { CustomSwitchInput } from '../components/CustomSwitchInput';
import { getSecureItemFromSpecificStorage, storeSecureItemInSpecifiedStorage } from '../lib/BrowserStorageAccessMiddleware';
import { LOCAL_STORAGE, LS_TENANT_ASSIGNMENT_LOCKER_BANK_SETTINGS, LS_CUSTOMER, TXN_ID, SS_REDIRECTED_FROM_LOGIN, IS_LOGGED_IN, LS_DOMAIN_AND_LOCKER_BANK, LS_ASSIGNMENT_SLUG, LS_BANKID, IS_OTP_SEND, LS_LOCKER_BANK_INFO, LS_PHONE_PREFIX, LS_PHONE_NUMBER_LENGTH } from '../assets/constants/BrowserStorageKeys';
import { handleStoreUserDataInLocalStorage, hasExtraAuthMethods, removeSpacesAndHyphens, getPathForNextPage, GetAvailableLockerSizesAndRedirectUser, getDotCount, bgImage } from '../lib/Utils';
import { AnonymousUserAuthentication, getAvailableLockerSizesWithUnits, registerFacebookLoginUser, registerGoogleLoginUser, sendOtp } from '../api/api';
import packageJson from '../../package.json';
import CircularProgressLoader from '../components/CircularProgressLoader';
import CustomDialog from '../components/CustomDialog';
import CustomQRCodeReader from '../components/CustomQRCodeReader';
import { ReactComponent as DuroltLogoIcon } from "../assets/images/durolt_logo_new.svg";
import OtpInput from '../components/OtpInput';
import AuthButtons from '../components/ExtraAuthButtons';
import { RenderTabs } from '../components/RenderTabsComponent';

const LoginScreen = () => {
    const history = useHistory();
    const isLoggedIn = getSecureItemFromSpecificStorage(LOCAL_STORAGE, IS_LOGGED_IN);
    if (isLoggedIn) {
        history.replace({
            pathname: getPathForNextPage(LOGIN, HOME)
        });
    };

    const [areTermsAndConditionsAccepted, setAreTermsAndConditionsAccepted] = useState(true);
    const [installAppPrompt, setInstallAppPrompt] = useState(null);
    const [showInstallAppModal, setShowInstallAppModal] = useState(false);
    const [isQrCodeReaderVisible, setIsQrCodeReaderVisible] = useState(false);
    const [isDialogVisible, setIsDialogVisible] = useState(false);
    const [dialogContentText, setDialogContentText] = useState('');
    const [mobile, setMobile] = useState('');
    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isGoogleLoginLoading, setIsGoogleLoginLoading] = useState(false);
    const [isFacebooLoginkLoading, setIsFacebookLoginLoading] = useState(false);
    const [selCountryLength, setSelCountryLength] = useState(0)
    const [disabled, setDisabled] = useState(true);
    const [errorMessage,setErrorMessage] = useState('');
    const { t } = useTranslation();
    const assignmentSettings = getSecureItemFromSpecificStorage(LOCAL_STORAGE,LS_TENANT_ASSIGNMENT_LOCKER_BANK_SETTINGS);
    const [isMobile, setIsMobile] = useState(assignmentSettings?.usecase_settings?.verify_with_mobile_otp_pwa?.value);
    const [type, setType] = useState(assignmentSettings?.usecase_settings?.verify_with_mobile_otp_pwa?.value ? 'Mobile' : 'Email');
    const hasSwitchedAuthMethod = assignmentSettings?.usecase_settings?.verify_with_mobile_otp_pwa?.value && assignmentSettings?.usecase_settings?.verify_with_email_otp_pwa?.value;
    const theme = useTheme();
    const [tabValue, setTabValue] = useState(0);
    const customer = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_CUSTOMER);      
    const [provider, setProvider] = useState('')
    const [profile, setProfile] = useState(null)
    const [showLoader, setShowLoader] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState('');
    const isLoginWithGoogle = assignmentSettings?.usecase_settings?.login_with_google_pwa?.value; 
    const isLoginWithFacebook = assignmentSettings?.usecase_settings?.login_with_facebook_pwa?.value;
    const isEmailOtpEnabled = assignmentSettings?.usecase_settings?.verify_with_email_otp_pwa?.value;
    const isMobileOtpEnabled = assignmentSettings?.usecase_settings?.verify_with_mobile_otp_pwa?.value;
    const assignmentSlug = assignmentSettings?.slug;
    const anonymous_user = assignmentSettings?.usecase_settings?.allow_anonymous_drop_pwa?.value;
    const lockerBankId = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_DOMAIN_AND_LOCKER_BANK)?.lockerBankId;
    const toShowAuthOptions = assignmentSettings?.usecase_settings?.show_drop_btn_pwa?.value && assignmentSettings?.usecase_settings?.show_pickup_btn_pwa?.value;
    const [showAuthOptions, setShowAuthOptions] = useState(toShowAuthOptions);
    const [isShowLoginField, setIsShowLoginField] = useState(! showAuthOptions);
    const lockerBankInfo = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_LOCKER_BANK_INFO);
    const[isOTPVerificationFiledEnabled,setIsOTPVerificationFiledEnabled] = useState(false);
    const[isShowSendOTPButtonEnabled,setIsShowSendOTPButtonEnabled] = useState(true);
    // histrory proprs data 
    const { bookingObject = [{}] , finalGSTObject} = history.location?.state || {};
    const settings = {
        isOTPlessLoginEnabled: false,
        show_otp_inputs_with_tabs : customer === "HiveBoard" ? true : false
    }

    useEffect(() => {
        storeSecureItemInSpecifiedStorage(LOCAL_STORAGE, LS_BANKID, lockerBankId);
        storeSecureItemInSpecifiedStorage(LOCAL_STORAGE, LS_ASSIGNMENT_SLUG, assignmentSlug);
        const handleBeforeInstallAppPrompt = (e) => {
            e.preventDefault();
            setInstallAppPrompt(e);
        };

        window.addEventListener('beforeinstallprompt', handleBeforeInstallAppPrompt);

        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallAppPrompt);
        };
    }, []);

    const toggleInput = (value) => {
        setMobile('');
        setEmail('');
        setErrorMessage('');

        if (value === 0) {
            setIsMobile(true);
            setType('Mobile');
        } else {
            setIsMobile(false);
            setType('Email');
        }
        /*
        hide the visible verify otp boxes and reset button and show the submit button
        */
        setIsOTPVerificationFiledEnabled(false);
        setIsShowSendOTPButtonEnabled(true);
    };

    const getToken = async () => {
        const isLoggedIn = localStorage.getItem('isLoggedIn');
        if (isLoggedIn === 'false' || isLoggedIn === null) {
            localStorage.removeItem('token');
        }
    };

    useEffect(() => {

        if (settings?.isOTPlessLoginEnabled) {
            constructAndAppendOTPlessScriptElement();
        }
        getUserDetailsAfterOTPlessAuthentication();
        getToken();
    }, []);

    const onLoginStart = useCallback(() => {
        setLoadingMessage(t('pleaseWaitText'));
        setShowLoader(true);
      }, [])

      const onLogoutSuccess = useCallback(() => {
        setProfile(null)
        setProvider('')
        alert('logout success')
      }, [])

    const constructAndAppendOTPlessScriptElement = () => {
        const otplessScriptElement = document.createElement("script");
        otplessScriptElement.src = OTPLESS_AUTHENTICATION_SOURCE;
        otplessScriptElement.cid = OTPLESS_DUROLT_CID;
        otplessScriptElement.id = "otpless-script";

        const otplessLoginPageElement = document.getElementById("otpless-login-page");
        otplessLoginPageElement.appendChild(otplessScriptElement);
    }

    const getUserDetailsAfterOTPlessAuthentication = () => {
        window.otpless = (otplessUserDetails) => {
            alert("Auth page OTPLess alert:" + JSON.stringify(otplessUserDetails));
            if (settings?.isOTPlessLoginEnabled) { removeOTPlessScriptAndWidgetWhenRedirectingToAnotherPage() }
            history.push({ pathname: getPathForNextPage(HOME, LOCKER_SIZE_SELECTION) });
        }
    }

    const removeOTPlessScriptAndWidgetWhenRedirectingToAnotherPage = () => {
        document.getElementById("otpless-script")?.remove();
        document.getElementById("otpless-floating-button")?.remove();
        document.getElementById("otpless-loader-style")?.remove();
    }

    /**
     * The `isMobileValid` function checks if a mobile number is valid based on certain conditions and
     * displays corresponding toasts if validation fails.
     */
    const validation = () => {
        
        const isMobileValid = () => {
            if (mobile.trim() === '') {
                ShowToast(t('LoginPhoneError'), TOAST_WARN);
                return false;
            }
            return true;
        };

        /**
         * The function `isEmailValid` checks if an email is valid and displays a toast message
         * accordingly.
         * @returns The function `isEmailValid` will return a boolean value - `true` if the email is valid
         * based on the conditions specified in the function, and `false` if the email is not valid.
         */
        const isEmailValid = () => {
            if (email.trim() === '') {
                ShowToast(t('LoginEmailError'), TOAST_WARN);
                return false;
            } else if (!REGEXP_EMAIL.test(email.trim())) {
                ShowToast(t('OTPSentEmailFailed'), TOAST_ERROR);
                return false;
            }
            return true;
        };

        if (type === 'Mobile') {
            if (isMobileValid()) {
                let mobileNumber = removeSpacesAndHyphens(mobile);
                sendOTPRequest(mobileNumber, 'phone');
            }
        } else if (isEmailValid()) {
            sendOTPRequest(email, 'email');
        }
    };

    /**
     * The function `sendOTPRequest` is an asynchronous function that sends an OTP request based on
     * user input, handles the response, and displays appropriate messages.
     * @param toggle - The `toggle` parameter in the `sendOTPRequest` function is used to determine
     * whether the OTP should be sent to a mobile number or an email address. It helps in deciding the
     * communication channel for sending the OTP.
     */
    const sendOTPRequest = async (userInput,toggle) => {
        try {
            if(assignmentSettings && userInput !== ''){
                setIsLoading(true);
                let assignmentSlug = assignmentSettings?.slug;
                const response = await sendOtp(userInput,assignmentSlug);
                if (response.status == SUCCESS) {
                    let txnId = response?.data?.txn_id;
                    storeSecureItemInSpecifiedStorage(LOCAL_STORAGE, TXN_ID, txnId);
                    setIsLoading(false);
                    let isOTPSend = response?.data?.is_otp_sent
                    if(isOTPSend){
                        ShowToast(t('OTPSentSuccessfully'), TOAST_SUCCESS);
                        // show otp input fields only when otp is sent successfully, if otp sending fails then user can edit the input and try again
                    }else{
                        ShowToast(t('sameOtp'), TOAST_SUCCESS);
                    }
                    setIsOTPVerificationFiledEnabled(true);
                    setIsShowSendOTPButtonEnabled(false);
                    
                    storeSecureItemInSpecifiedStorage(LOCAL_STORAGE, IS_OTP_SEND, isOTPSend);
                    //history.push(getPathForNextPage(LOGIN, VERIFY_OTP), { userInput: userInput, toggle: toggle })
                } else {
                    setIsLoading(false);
                    ShowToast(toggle === 'Mobile' ? t('OTPSentPhoneFailed') : t('OTPSentEmailFailed'), TOAST_ERROR);
                }
            }
        } catch (error) {
            setIsLoading(false);
            console.error('Error while sending OTP:', error);

            if (error?.response?.status === 406 && error?.response?.data?.message?.includes('Invalid Data')) {
                const errorMessage = `${t('Error_Send_OTP')} ${/\+\d+/.test(userInput) ? t('phoneNumberLabel') : t('emailAddressLabel')}.`;
                ShowToast(errorMessage, TOAST_ERROR);
            }
        }
    };


    const qrCodeReaderScanHandler = async (qrCodeData) => {
        try {
            if (qrCodeData && qrCodeData.length > 0) {
                const qrCodeLink = qrCodeData[0]?.rawValue;
                const pathnameWithTrailingSlash = `${getPathForNextPage(LOGIN, LINK_MY_DEVICE)}/`;
                const doPwaDomainAndQrCodeLinkDomainMatch = (pwaEnvironment) => {
                    if (pwaEnvironment === 'prod' && qrCodeLink.includes('app.durolt.com')) {
                        return true;
                    }
                    if (pwaEnvironment === 'uat' && qrCodeLink.includes('appdemo.durolt.in')) {
                        return true;
                    }
                    if ((pwaEnvironment === 'dev' || pwaEnvironment === 'local') && qrCodeLink.includes('app.durolt.in')) {
                        return true;
                    }

                    return false;
                }

                if ( !(qrCodeLink.includes(pathnameWithTrailingSlash)) || !(doPwaDomainAndQrCodeLinkDomainMatch(process.env.REACT_APP_ENV)) ) {
                    setDialogContentText(t('Invalid_QR_Link_My_Phone'));
                    setIsDialogVisible(true);
                    setIsQrCodeReaderVisible(false);
                    return;
                }

                const startIndex = qrCodeLink.indexOf(pathnameWithTrailingSlash);
                const base64StringWithTrailingSlash = qrCodeLink.substring(startIndex + pathnameWithTrailingSlash.length);
                const redirectionPathWithParameter = `${pathnameWithTrailingSlash}${base64StringWithTrailingSlash}`;
                

                history.push({
                    pathname: redirectionPathWithParameter
                });
            }
        } catch (error) {
            console.error('Error while scanning link my device QR code: ', error);
            setDialogContentText(t('Error_Link_MyPhone'));
            setIsDialogVisible(true);
            setIsQrCodeReaderVisible(false);
        }
        // localStorage.setItem('Is_Guest', 'false');
        // history.push(getPathForNextPage(LOGIN, LINK_MY_DEVICE));
    };

    const qrCodeReaderErrorHandler = async (error) => {
        console.error('Error while scanning link my device QR code: ', error);
    }

    /**
     * Handles setting the mobile value and selected country length.
     * @param {string} value - The value of the input field.
     * @param {object} country - The selected country object.
     * @param {object} e - The event object.
     */
    const handleSetMobile = (value, country, e) => {
        const phoneNumber = e.target.value;
        let phonePrfix = country.format[0]+country.dialCode;
        const format = country.format;
        const sliced = format.slice(format.indexOf(" ") + 1);
        const dotCount = getDotCount(sliced);
        storeSecureItemInSpecifiedStorage(LOCAL_STORAGE, LS_PHONE_PREFIX, phonePrfix);
        storeSecureItemInSpecifiedStorage(LOCAL_STORAGE, LS_PHONE_NUMBER_LENGTH, dotCount);
        if (phoneNumber) {
            setSelCountryLength(country.format.length);
            setMobile(phoneNumber);

            // Validate phone number (example validation: length check)
            const isValidPhoneNumber = phoneNumber.length > 8 ? true : false;

            if (!isValidPhoneNumber) {
                setErrorMessage(t('LoginPhoneError'));
            } else {
                setErrorMessage('');
            }
            setDisabled(!isValidPhoneNumber);
        }
    };


    /**
     * Handles the change event of the email input field.
     * 
     * @param {Event} e - The event object.
     * @returns {void}
     */
    const handleSetEmail = (e) => {
        const email = e.target.value;
        setEmail(email);

        if (!REGEXP_EMAIL.test(email)) {
            setErrorMessage(t('LoginEmailError'));
        } else {
            setErrorMessage('');
        }
        setDisabled(!REGEXP_EMAIL.test(email));
    };

    const handleChange = (newValue) => {
        setTabValue(newValue);
        toggleInput(newValue);
    };

    const handleRegisterGoogleUser = async (userData) => {
        try {
            const googleAccessToken = userData?.access_token;
            const email = userData?.email
            if (googleAccessToken && email) {
                const response = await registerGoogleLoginUser(googleAccessToken, assignmentSlug, email);
                if (response.status === SUCCESS) {
                    setShowLoader(false);
                    let userInfo = response?.data
                    handleStoreUserDataInLocalStorage(userInfo)
                    sessionStorage.setItem(SS_REDIRECTED_FROM_LOGIN, true);
                    history.push(getPathForNextPage(LOGIN, HOME));
                } else {
                    setShowLoader(false);
                }
            } else {
                setShowLoader(false);
            }
        } catch (error) {
            setShowLoader(false);
            console.error("Error while registering Google user:", error);
        }
    }

    const handleRegisterFacebookUser = async (userData) => {
        try {
            const faceBookAuthToken = userData?.accessToken;
            const email = userData?.email
            if (faceBookAuthToken && email) {
                const response = await registerFacebookLoginUser(faceBookAuthToken, assignmentSlug, email);
                if (response.status === SUCCESS) {
                    setShowLoader(false);
                    let userInfo = response?.data
                    handleStoreUserDataInLocalStorage(userInfo)
                    sessionStorage.setItem(SS_REDIRECTED_FROM_LOGIN, true);
                    history.push(getPathForNextPage(LOGIN, HOME));
                } else {
                    setShowLoader(false);
                }
            } else {
                setShowLoader(false);
            }
        } catch (error) {
            setShowLoader(false);
            console.error("Error while registering Google user:", error);
        }
    }

    const handleInstallAppButtonClick = async () => {
        const userAgent = navigator.userAgent;
        const isAppleDevice = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        const isSafariBrowser = /Safari/.test(userAgent) && !/Chrome/.test(userAgent);

        if (isAppleDevice && isSafariBrowser) {
            setShowInstallAppModal(true);
        }
        else if (installAppPrompt) {
            try {
                installAppPrompt.prompt();

                setInstallAppPrompt(null);
            } catch (error) {
                console.error('Install app prompt error: ', error);
            }
        }
        else if (window.matchMedia('(display-mode: standalone)').matches) {
            alert(t('Already_Installed'));
        }
        else {
            alert(t('Install_Not_Available'));
        }
    };

    const renderInstallAppModalContent = () => {
        return (
            <Box className='modal-content'>
                <Typography className='install-text'>{t('ios_install_instructions_title')}</Typography>
                <Box className='instructions-list'>
                    <Typography className='instruction'>
                        <Trans
                            i18nKey="ios_install_step_1"
                            components={{
                                b: <b />,
                                shareIcon: <IosShareRounded className='instruction-icon' />,
                            }}
                        />
                    </Typography>
                    <Typography className='instruction'>
                        <Trans
                            i18nKey="ios_install_step_2"
                            components={{
                                b: <b />,
                                addIcon: <AddBoxOutlined className='instruction-icon' />,
                            }}
                        />
                    </Typography>
                    <Typography className='instruction'>
                        <Trans i18nKey="ios_install_step_3" components={{ b: <b /> }} />
                    </Typography>
                </Box>
            </Box>
        );
    };
    const handleDropUser = async()=>{
        if(anonymous_user){
            try{
                const response = await AnonymousUserAuthentication(assignmentSlug);
                if(response?.data){
                    const UserData = response.data
                    handleStoreUserDataInLocalStorage(UserData);
                    await GetAvailableLockerSizesAndRedirectUser(lockerBankInfo,lockerBankId,UserData?.id, assignmentSettings?.is_pricing, history); 
                }
            }
            catch(error){
                console.log(`error during calling the AnonymousUserAuthentication api`);
            }
        }
        else{
            setIsShowLoginField(true);
        }
        setShowAuthOptions(false);  
    }
    const handlePickupUser = ()=>{
        history.push(getPathForNextPage(LOGIN, DOOR_VERIFICATION_PAGE));
    }
    const renderAuthenticationOption = ()=>{
        return(
            <div className='all-authentication-buttons-container'>
                <div className='main'>
                {
                    assignmentSettings?.usecase_settings?.show_drop_btn_pwa?.value && 
                    <ButtonComponent className="drop-button-class" title={'button_dropUser'} handleClick={handleDropUser}/>
                }
                {
                    assignmentSettings?.usecase_settings?.show_pickup_btn_pwa?.value &&
                    <ButtonComponent className='pickup-button-class' title={'button_pickUser'} handleClick={handlePickupUser}/>
                }
                </div>
            </div>
        )
    }

        return (
        // <Box className={`login-screen-page ${bgImage(t, assignmentSettings) ? "img" : ""}`}
        //     sx={{backgroundImage: bgImage(t, assignmentSettings) ? `url(${bgImage(t,assignmentSettings)})` : "none",}}
        // >
        <Box className={`login-screen-page ${t("backgroundImage") ? 'img' : ''}`}
            sx={{backgroundImage : t("backgroundImage") ? `url(${t("backgroundImage")})` : ""}}
        >
        {
            showAuthOptions  ?
            renderAuthenticationOption()
            :
            isShowLoginField  ?
            <Box className='main-container'>
                {isQrCodeReaderVisible ? (
                    <Box className='main'>
                        <Box className='qr-code-reader'>
                            <CustomQRCodeReader
                                handleOnScan={qrCodeReaderScanHandler}
                                handleOnError={qrCodeReaderErrorHandler}
                            />
                            <Typography className='qr-code-heading'>{t('Scan_QR_To_Link_Device')}</Typography>
                            <ButtonComponent handleClick={() => setIsQrCodeReaderVisible(false)} title={'button_cancel'} type={BUTTON_WARNING} />
                        </Box>
                    </Box>
                ) : (
                    <Box className='main'>
                        <Box className="logo_style">
                            {t("logo") !== "logo" ? <img  height={80} width={93} src={t("logo")}/> :
                            <DuroltLogoIcon width={100} height={40} />}
                        </Box>
                        <div className="formView">
                            <h2 className='text'> {t('loginTitle')} </h2>
                            <p className='anotherText'> {t('loginText')} </p>
                            <div className='input-tab-bar-container'>
                            <RenderTabs
                                isMobileOtpEnabled={isMobileOtpEnabled}
                                isEmailOtpEnabled={isEmailOtpEnabled}
                                tabValue={tabValue}
                                onChange={handleChange}
                                t={t}
                            />
                            
                            </div>
                                {(assignmentSettings?.usecase_settings?.verify_with_mobile_otp_pwa?.value || assignmentSettings?.usecase_settings?.verify_with_email_otp_pwa?.value) &&
                                <>
                                <CustomSwitchInput
                                    isMobile={isMobile}
                                    mobile={mobile}
                                    email={email}
                                    handleSetMobile={handleSetMobile}
                                    toggleInput={toggleInput}
                                    handleSetEmail={handleSetEmail}
                                    validation={validation}
                                    error={!!errorMessage}
                                    hasSwitchedAuthMethod={hasSwitchedAuthMethod}
                                    disabled={disabled}
                                    enableTabs={settings?.show_otp_inputs_with_tabs}
                                />
                            {errorMessage && <Typography className="login-error-message">{errorMessage}</Typography>}
                            <Box className="login-button">
                                {isShowSendOTPButtonEnabled &&
                                <ButtonComponent  align="right"  type="custom" handleClick={validation} title={isLoading ? '' : 'loginBtnText'}  disabled={customer === "Durolt" && disabled} />
                                }
                            </Box>
                            </>
                            }
                            
                             {/* to render the otp boxes */}
                             {isOTPVerificationFiledEnabled && 
                            <OtpInput 
                            bookingObject = {bookingObject}
                            finalGSTObject = {finalGSTObject}
                            length={4}  userInput={mobile ? mobile : email} />}

                            {(hasExtraAuthMethods(assignmentSettings?.usecase_settings) || isLoginWithGoogle && isLoginWithFacebook) &&
                            <>
                                <div className='textORMainContainer'>
                                    <div className='textORLine' />
                                        <div className='textORContainer'>
                                            <p className='shareText'>
                                            {t('orText')}
                                            </p>
                                        </div>
                                    <div className='textORLine' />
                                </div>
                                
                            <div className="auth-container">
                                <p className="auth-title">{t('sign_in_with_text')}</p>
                                <div className="auth-buttons">
                                    <LoginSocialGoogle
                                        client_id={process.env.REACT_APP_GG_APP_ID || ''}
                                        scope="openid profile email"
                                        // redirect_uri={}
                                        onLoginStart={onLoginStart}
                                        onResolve={({ provider, data }) => {
                                            setProvider(provider);
                                            setProfile(data);
                                            handleRegisterGoogleUser(data)
                                        }}
                                        onReject={(err) => {
                                            setShowLoader(false);
                                            console.log("Error", err);
                                        }}>
                                        {isLoginWithGoogle && 
                                        <ButtonComponent  
                                        buttonId='login-with-google-button'
                                        type="auth"
                                        customClass="auth-button"
                                        centerIcon={<GoogleIcon />}
                                        handleClick={() => { }} title={isGoogleLoginLoading ? <CircularProgress size={24} /> : t("loginWithGoogleLabel")} />}
                                    </LoginSocialGoogle>
                                    <LoginSocialFacebook
                                        appId={process.env.REACT_APP_FB_APP_ID || ''}
                                        onLoginStart={onLoginStart}
                                        onResolve={({ provider, data }) => {
                                            setProvider(provider)
                                            setProfile(data)
                                            handleRegisterFacebookUser(data)
                                        }}
                                        onReject={(err) => {
                                            setShowLoader(false);
                                            console.log(err)
                                        }}
                                    >
                                    {isLoginWithFacebook && <ButtonComponent  type="auth"  customClass="auth-button" buttonId='login-with-facebook-button' handleClick={() => {}} 
                                        title={isFacebooLoginkLoading ? <CircularProgress size={24} /> : t("loginWithFacebookLabel")} centerIcon={<FaceBookIcon />} />}
                                    </LoginSocialFacebook> 
                                    {assignmentSettings?.usecase_settings?.link_my_device?.value &&
                                        <ButtonComponent buttonId='link-my-device-button' handleClick={() => setIsQrCodeReaderVisible(true)} title={'scanBtnText'} 
                                        type="auth"  customClass="auth-button" 
                                        centerIcon={<FaceBookIcon />} />}
                                </div>
                            </div>
                            </>
                        }
                        </div>

                        {/*extra auth options */}
                        {/* {(hasExtraAuthMethods(assignmentSettings?.usecase_settings) || 
                            isLoginWithGoogle || 
                            isLoginWithFacebook || 
                            assignmentSettings?.usecase_settings?.link_my_device?.value) && (
                            
                            <>
                                <div className='textORMainContainer'>
                                    <div className='textORLine' />
                                        <div className='textORContainer'>
                                            <p className='shareText'>
                                            {t('orText')}
                                            </p>
                                        </div>
                                    <div className='textORLine' />
                                </div>

                                <AuthButtons
                                isLoginWithFacebook={isLoginWithFacebook}
                                LoginWithFacebookHandler={() => console.log("facebook login button clicked")}
                                isLoginWithGoogle={isLoginWithGoogle}
                                handleRegisterGoogleUser={ handleRegisterGoogleUser}
                                linkMyDevice={assignmentSettings?.usecase_settings?.link_my_device?.value}
                                linkMyDeviceHandler={() => setIsQrCodeReaderVisible(true)}
                                />
                            </>
                            )} */}

                        {settings?.isOTPlessLoginEnabled && (
                            <Box className="otpless-login-page-container">
                                <Box id="otpless-login-page"></Box>
                            </Box>
                        )}
                        <div className="login-footer">
                            <ButtonComponent
                                buttonId='install-app-button'
                                handleClick={handleInstallAppButtonClick}
                                title={'Install_App'}
                                startIcon={<InstallMobileRounded />}
                                type={'iceBlue'}
                            />
                            <Box className="loginPageFooterText">
                                <Typography className='footerTextStyle'>
                                    {t('appVersionText')} {process.env.REACT_APP_RELEASE_VERSION}
                                </Typography>
                            </Box>
                        </div>
                    </Box>
                )}
                <CustomDialog
                    dialogId='error-dialog'
                    dialogVisible={isDialogVisible}
                    dialogTitle={t('page_title_error')}
                    dialogContentText={dialogContentText}
                    buttonTwoTitle={t('button_ok')}
                    buttonProps={{ buttonTwo: { type: BUTTON_PRIMARY } }}
                    handleAccept={() => setIsDialogVisible(false)}
                />
                <CustomDialog
                    dialogId='install-app-instructions-modal'
                    dialogVisible={showInstallAppModal}
                    dialogTitle={t('Install_App')}
                    children={renderInstallAppModalContent}
                    buttonTwoTitle={t('button_ok')}
                    buttonProps={{buttonTwo: {type: BUTTON_PRIMARY}}}
                    handleAccept={() => setShowInstallAppModal(false)}
                    onClose={() => setShowInstallAppModal(false)}
                />
            </Box> : null 
        }
            
            {showLoader && (<CircularProgressLoader message={loadingMessage} />)}
        </Box>
    );
};

export default LoginScreen;
